export default __webpack_public_path__ + "static/media/delivero.13d94fb4.png";